module.exports = __webpack_public_path__ + "static/media/iconeSeta.99d6b104.svg";